(() => {
  class ModelLinks extends HTMLElement {
    connectedCallback() { this.addEventListener('change', this.handleChange); }
    disconnectedCallback() { this.removeEventListener('change', this.handleChange); }
    handleChange = event => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || !select.matches('[data-model-links-select]')) return;
      if (!select.value || (select.value === this.dataset.currentUrl && !window.ssProductSwitch?.busy)) return;
      const target = new URL(select.value, location.origin);
      if (target.origin !== location.origin) return;
      new URL(location.href).searchParams.forEach((value, name) => {
        if (/^utm_/i.test(name) || ['gclid','fbclid','msclkid','ttclid','preview_theme_id'].includes(name)) target.searchParams.set(name, value);
      });
      target.searchParams.delete('style');
      target.searchParams.delete('variant');
      if(this.dispatchEvent(new CustomEvent('ss:product-navigate',{bubbles:true,cancelable:true,detail:{url:target.href,focusMode:'model'}})))location.assign(target.href);
    };
  }
  if (!customElements.get('model-links')) customElements.define('model-links', ModelLinks);
})();
